import React from 'react';

import { gql } from '@apollo/client';

import { ActivityLogTaskMigrated_ActivityLogFragment } from 'src/generated/mloop-graphql';

import { FCWithFragments } from 'src/components/types';

import ActivityLogBase from '../../Helpers/ActivityLogBase';

interface Fragments {
  activityLog: ActivityLogTaskMigrated_ActivityLogFragment;
}

const ActivityLogTaskMigrated: FCWithFragments<Fragments> = ({ activityLog }) => {
  return (
    <ActivityLogBase
      activityLog={activityLog}
      actionLabelKey="hiring-dashboard-candidates:candidates.activityLog.taskMigrated"
    />
  );
};

ActivityLogTaskMigrated.fragments = {
  activityLog: gql`
    ${ActivityLogBase.fragments.activityLog}
    fragment ActivityLogTaskMigrated_activityLog on ActivityLog {
      id

      ...ActivityLogBase_activityLog
    }
  `,
};

export default ActivityLogTaskMigrated;
